import React, { Component } from 'react';

import { ModalContainer } from '../guardedModal/ModalContainer';

import { updateClient } from 'api/clients/clients.actions';
import AppModal from 'components/modal/appModal';

export class ClipPreviewRequestedModalContent extends Component<any> {
  markAsRead = () => {
    const { dispatch, clientId, onClose } = this.props;

    dispatch(updateClient(clientId, { clipPreviewUpdated: false }))
      .then(({ payload }: any) => {
        onClose(payload);
      })
      // eslint-disable-next-line no-console
      .catch(console.error);
  };

  render() {
    const { id, active } = this.props;

    return (
      // @ts-ignore
      <AppModal id={id} title="Clip preview" hideOpenButton closeButtonLabel="Mark as read" onClose={this.markAsRead}>
        {active && <div>Client has requested a clip preview.</div>}
        {!active && <div>Client has not requested clip preview yet.</div>}
      </AppModal>
    );
  }
}

type ClipPreviewRequestedModalProps = { onClose: (response: any) => void };

export const ClipPreviewRequestedModal = (props: ClipPreviewRequestedModalProps) => {
  const { onClose } = props;

  return (
    <ModalContainer id="clip-preview-requested-modal">
      <ClipPreviewRequestedModalContent onClose={onClose} />
    </ModalContainer>
  );
};
